import React, { useState } from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import DataEntryModal from '@grnhse/seedling/lib/birch/components/modals/data_entry_modal';
import {
  SimpleSingleDropdown,
  type Item,
} from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import type {
  SavedSearchGroup,
  SavedSearchItem,
} from 'talent_search/shared/types';

const t = withLocalePrefix(
  'talent_matching.rediscovery.filter_row.saved_filters'
);

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  options: SavedSearchGroup[];
  onSelect: (option: SavedSearchItem | null) => void;
};

const LoadFiltersModal = ({ isOpen, onDismiss, options, onSelect }: Props) => {
  const dropdownItems = options.map((group) => ({
    label: group.text,
    disabled: true,
    items: (group.items || []).map((item) => ({
      label: item.label,
      value: item,
      id: item.id,
    })),
  }));

  const [selected, setSelected] = useState<SavedSearchItem | null>(null);

  const handleApply = () => {
    onSelect(selected ?? null);
    onDismiss();
  };

  const handleDismiss = () => {
    setSelected(null);
    onDismiss();
  };

  return (
    <DataEntryModal
      size="medium"
      isOpen={isOpen}
      onDismiss={handleDismiss}
      ariaLabel={t('load_filter_aria_label')}
    >
      <DataEntryModal.Header onClick={handleDismiss}>
        {t('load')}
      </DataEntryModal.Header>
      <DataEntryModal.Body>
        <Stack sx={{ marginBottom: 2 }}>
          <SimpleSingleDropdown<SavedSearchItem>
            selectedItem={selected as Item<SavedSearchItem> | null}
            items={dropdownItems as unknown as Item<SavedSearchItem>[]}
            onSelectedItemChange={(item) => setSelected(item ?? null)}
            ariaLabel={t('load_filter_aria_label')}
            placeholder={t('load_label')}
          />
        </Stack>
      </DataEntryModal.Body>
      <DataEntryModal.Footer>
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <SecondaryButton onClick={handleDismiss}>
            {t('cancel')}
          </SecondaryButton>
          <PrimaryButton onClick={handleApply} disabled={!selected}>
            {t('apply_filters')}
          </PrimaryButton>
        </Stack>
      </DataEntryModal.Footer>
    </DataEntryModal>
  );
};

export default LoadFiltersModal;
